import {searchHandler} from "./search"
import {hamburgerNavigationToggler, activeNavToggler, headerDropdownSupplements} from './navigation'
import {
    onInitSymptomsTest,
} from './check-symptoms-custom'
import { accordionHandler } from './accordionHandler'
import { filterToggleClose } from './filterToggleClose'
import { subscribeHandler } from './subscribe'

$(document).ready(function () {
    searchHandler()
    hamburgerNavigationToggler()
    activeNavToggler()
    accordionHandler()
    filterToggleClose()
    onInitSymptomsTest()
    subscribeHandler()
    headerDropdownSupplements()
    showBanner()
});

const $footerBanner = $('#footer-banner');
const $closeBanner = $('#close-banner');

function showBanner() {
    if (!sessionStorage.getItem('bannerClosed')) {
        $footerBanner.css('display', 'block');
    }
}

function hideBanner() {
    $footerBanner.css('display', 'none');
    sessionStorage.setItem('bannerClosed', 'true');
}

$closeBanner.on('click', hideBanner);